import React, { useEffect } from 'react'

type GiftToastProps = {
  visible: boolean
  emoji: string
  label: string
  detail?: string
  kind?: 'success' | 'error'
  onHide: () => void
  timeoutMs?: number
}

export default function GiftToast({ visible, emoji, label, detail, kind = 'success', onHide, timeoutMs = 1800 }: GiftToastProps) {
  useEffect(() => {
    if (!visible) return
    const t = setTimeout(onHide, timeoutMs)
    return () => clearTimeout(t)
  }, [visible, onHide, timeoutMs])

  if (!visible) return null
  return (
    <div className="fixed left-1/2 -translate-x-1/2 bottom-6 z-50">
      <style>{`
        @keyframes gift_toast_pop {
          0% { transform: translate3d(0, 10px, 0) scale(0.96); opacity: 0; }
          60% { transform: translate3d(0, 0, 0) scale(1.02); opacity: 1; }
          100% { transform: translate3d(0, 0, 0) scale(1); opacity: 1; }
        }
      `}</style>
      <div
        className={`px-4 py-2 rounded-full glass border flex items-center gap-2`}
        style={{
          animation: 'gift_toast_pop 320ms cubic-bezier(.2,.8,.2,1) both',
          borderColor: kind === 'error' ? 'rgba(244,63,94,0.35)' : 'rgba(255,255,255,0.12)',
        }}
      >
        <div className="text-xl">{emoji}</div>
        <div className="text-sm">
          <div className="font-semibold">{label}</div>
          {detail && <div className="text-white/80">{detail}</div>}
        </div>
      </div>
    </div>
  )
}
